module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Right-circle-8d2f985d15a78c25cff7385d8261c32b.svg";